module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/logo-part-2.060cda9b.png";